import styled from 'styled-components'

type listItemProps = {
  justifyContent?: string
}

const ListWrapper = styled.ul<listItemProps>`
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    display: flex;
    align-items: center;
    justify-content: ${(props) =>
      props.justifyContent ? props.justifyContent : 'flex-start'};
    gap: 12px;
    padding: 12px;
    border-bottom: 1px solid ${(props) => props.theme.border.color};

    svg {
      width: 22px;
      fill: ${(props) => props.theme.body.textMuted};
    }

    &:last-child {
      border-bottom-width: 0;
    }
  }
`

type ILists = {
  items: Array<any>
  justifyContent?: string
}

export function Lists({ items, justifyContent }: ILists) {
  if (!items) return

  return (
    <ListWrapper justifyContent={justifyContent}>
      {items.map((item) => (
        <li
          key={item.key || (item.text.length > 0 && item.text.replace(' ', ''))}
        >
          {item.icon ? item.icon : ''} <span>{item.text}</span>
        </li>
      ))}
    </ListWrapper>
  )
}
